import {RegistrationModel} from 'models/registration/RegistrationModel'
import {StepConfig, StepKey, StepModel} from 'models/registration/StepModel'
import {WysiwygType} from 'types'
import {Memoize} from 'util/memoize'

export type OnsiteStepConfig = StepConfig & {
	popup_title: string
	popup_message: WysiwygType
}

export class OnsiteStepModel extends StepModel<OnsiteStepConfig> {
	constructor(registration: RegistrationModel, config?: OnsiteStepConfig) {
		super(
			registration,
			config || {
				text: '',
				title: '',
				breadcrumb: '',
				popup_title: '',
				popup_message: ''
			}
		)
	}

	@Memoize()
	get key(): StepKey {
		return 'onsite'
	}

	@Memoize()
	get isApplicable(): boolean {
		return this.registration.isOnsite
	}

	@Memoize()
	get isReady(): boolean {
		return true
	}
}
